module.exports = __webpack_public_path__ + "assets/03a0588e4bcb14c3606900a85471efe5.svg";